import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import './PolicyPage.css';
import { useSEO } from '../lib/seo';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function PolicyPage() {
  const { slug }     = useParams();

  const _policyTitle = {
    'privacy-policy': 'Privacy Policy',
    'refund-policy': 'Refund & Returns Policy',
    'terms-of-service': 'Terms of Service',
    'shipping-policy': 'Shipping Policy',
  }[slug] || 'Policy';
  useSEO({
    title: _policyTitle,
    description: `Read Naturiq's ${_policyTitle}. Transparent policies covering your orders, returns and data.`,
    url: `/policies/${slug}`,
  });
  const navigate     = useNavigate();
  const [policy, setPolicy]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    fetch(`${BASE}/api/policies/${slug}`)
      .then(r => {
        if (r.status === 404) throw new Error('not_found');
        if (!r.ok) throw new Error('server_error');
        return r.json();
      })
      .then(data => { setPolicy(data); setLoading(false); })
      .catch(err => {
        if (err.message === 'not_found') {
          navigate('/policies', { replace: true });
        } else {
          setError('Failed to load this policy. Please try again later.');
          setLoading(false);
        }
      });
  }, [slug, navigate]);

  const fmt = (iso) =>
    new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });

  if (loading) return (
    <div className="policy-page">
      <div className="policy-page__skel">
        <div className="skel" style={{ width: '30%', height: 13, borderRadius: 6 }} />
        <div className="skel" style={{ width: '65%', height: 34, borderRadius: 8, marginTop: 14 }} />
        <div className="skel" style={{ width: '25%', height: 12, borderRadius: 6, marginTop: 12 }} />
        <div className="policy-page__skel-body">
          {[100, 90, 95, 70, 88, 60, 92, 75].map((w, i) => (
            <div key={i} className="skel" style={{ width: `${w}%`, height: 13, borderRadius: 6 }} />
          ))}
        </div>
        <div className="skel" style={{ width: '45%', height: 20, borderRadius: 6, marginTop: 32 }} />
        <div className="policy-page__skel-body">
          {[85, 92, 78, 65].map((w, i) => (
            <div key={i} className="skel" style={{ width: `${w}%`, height: 13, borderRadius: 6 }} />
          ))}
        </div>
      </div>
    </div>
  );

  if (error) return (
    <div className="policy-page">
      <p className="policy-page__error">{error}</p>
    </div>
  );

  if (!policy) return null;

  return (
    <div className="policy-page">
      <h1 className="policy-page__title">{policy.title}</h1>
      {policy.updatedAt && (
        <p className="policy-page__meta">Last updated: {fmt(policy.updatedAt)}</p>
      )}

      <div
        className="policy-page__content"
        dangerouslySetInnerHTML={{ __html: policy.content }}
      />
    </div>
  );
}